import { authReducers } from './slices/auth';
import { IAuthData } from './slices/auth/initialState';
import { companyReducers } from './slices/company';
import { ICompanyData } from './slices/company/initialState';
import { interventionReducers } from './slices/intervention';
import { IInterventionData } from './slices/intervention/initialState';
import { treeTradeReducers } from './slices/treetrade';
import { ITreeTradeData } from './slices/treetrade/initialState';
import { workerReducers } from './slices/worker';
import { IWorkerData } from './slices/worker/initialState';

export interface IApplicationState {
  auth: IAuthData;
  company: ICompanyData;
  intervention: IInterventionData;
  treeTrade: ITreeTradeData;
  worker: IWorkerData;
}

const rootReducers = {
  auth: authReducers,
  worker: workerReducers,
  company: companyReducers,
  intervention: interventionReducers,
  treeTrade: treeTradeReducers,
};

export default rootReducers;
